"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: address_type.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressType = exports.protobufPackage = void 0;
exports.addressTypeFromJSON = addressTypeFromJSON;
exports.addressTypeToJSON = addressTypeToJSON;
/* eslint-disable */
exports.protobufPackage = "addresses";
var AddressType;
(function (AddressType) {
    AddressType[AddressType["ADDRESS_TYPE_UNSPECIFIED"] = 0] = "ADDRESS_TYPE_UNSPECIFIED";
    AddressType[AddressType["ADDRESS_TYPE_COUNTRY"] = 1] = "ADDRESS_TYPE_COUNTRY";
    AddressType[AddressType["ADDRESS_TYPE_PROVINCE_OR_STATE"] = 2] = "ADDRESS_TYPE_PROVINCE_OR_STATE";
    AddressType[AddressType["ADDRESS_TYPE_SUB_DIVISION"] = 3] = "ADDRESS_TYPE_SUB_DIVISION";
    AddressType[AddressType["ADDRESS_TYPE_NEIGHBOURHOOD"] = 4] = "ADDRESS_TYPE_NEIGHBOURHOOD";
    AddressType[AddressType["ADDRESS_TYPE_MULTI_UNIT"] = 5] = "ADDRESS_TYPE_MULTI_UNIT";
    AddressType[AddressType["ADDRESS_TYPE_ADDRESS"] = 6] = "ADDRESS_TYPE_ADDRESS";
    AddressType[AddressType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AddressType || (exports.AddressType = AddressType = {}));
function addressTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "ADDRESS_TYPE_UNSPECIFIED":
            return AddressType.ADDRESS_TYPE_UNSPECIFIED;
        case 1:
        case "ADDRESS_TYPE_COUNTRY":
            return AddressType.ADDRESS_TYPE_COUNTRY;
        case 2:
        case "ADDRESS_TYPE_PROVINCE_OR_STATE":
            return AddressType.ADDRESS_TYPE_PROVINCE_OR_STATE;
        case 3:
        case "ADDRESS_TYPE_SUB_DIVISION":
            return AddressType.ADDRESS_TYPE_SUB_DIVISION;
        case 4:
        case "ADDRESS_TYPE_NEIGHBOURHOOD":
            return AddressType.ADDRESS_TYPE_NEIGHBOURHOOD;
        case 5:
        case "ADDRESS_TYPE_MULTI_UNIT":
            return AddressType.ADDRESS_TYPE_MULTI_UNIT;
        case 6:
        case "ADDRESS_TYPE_ADDRESS":
            return AddressType.ADDRESS_TYPE_ADDRESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AddressType.UNRECOGNIZED;
    }
}
function addressTypeToJSON(object) {
    switch (object) {
        case AddressType.ADDRESS_TYPE_UNSPECIFIED:
            return "ADDRESS_TYPE_UNSPECIFIED";
        case AddressType.ADDRESS_TYPE_COUNTRY:
            return "ADDRESS_TYPE_COUNTRY";
        case AddressType.ADDRESS_TYPE_PROVINCE_OR_STATE:
            return "ADDRESS_TYPE_PROVINCE_OR_STATE";
        case AddressType.ADDRESS_TYPE_SUB_DIVISION:
            return "ADDRESS_TYPE_SUB_DIVISION";
        case AddressType.ADDRESS_TYPE_NEIGHBOURHOOD:
            return "ADDRESS_TYPE_NEIGHBOURHOOD";
        case AddressType.ADDRESS_TYPE_MULTI_UNIT:
            return "ADDRESS_TYPE_MULTI_UNIT";
        case AddressType.ADDRESS_TYPE_ADDRESS:
            return "ADDRESS_TYPE_ADDRESS";
        case AddressType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
//# sourceMappingURL=address_type.js.map